import moment from "moment";
import { CustomColumn } from "../..";
import { filterAction } from "../../processor";
import { FilterTableInfo, StatusOptions } from "./types";
import { getStatusApiValue } from "./utils";

interface SubmitHandlerParams<T> {
  filters: Record<string, any>;
  filteredCustomColumns: CustomColumn;
  statusOptions: StatusOptions;
  tableInfo: FilterTableInfo;
  initialData: T[];
  setFilteredData: (data: T[]) => void;
  onSubmit?: (filters: string) => void;
}

export const handleFilterSubmit = <T>({
  filters,
  filteredCustomColumns,
  statusOptions,
  tableInfo,
  initialData,
  setFilteredData,
  onSubmit
}: SubmitHandlerParams<T>) => {
  const { isUserManagementDetails } = tableInfo;
  const formattedFilters = { ...filters };
  const queryParams = new URLSearchParams();

  queryParams.append('per_page', '10');
  queryParams.append('page', '1');

  Object.entries(filteredCustomColumns).forEach(([key, columnDef]) => {
    if (columnDef.type === "date" && formattedFilters[key]?.keywords) {
      formattedFilters[key].keywords = formattedFilters[key].keywords.map(
        (date: string | null) =>
          date
            ? moment(date, ["YYYY/MM/DD", "DD/MM/YYYY"]).format("YYYY/MM/DD")
            : null
      );
    }

    if (isUserManagementDetails && key === "is_active") {
      if (formattedFilters[key]) {
        if (!formattedFilters[key].keywords) {
          formattedFilters[key].keywords = [];
        }
        
        if (!Array.isArray(formattedFilters[key].keywords)) {
          formattedFilters[key].keywords = [formattedFilters[key].keywords];
        }

        formattedFilters[key].keywords = formattedFilters[key].keywords.map(
          (val: string) => val.toLowerCase()
        );
      }
    }
    else if (columnDef.type === "boolean" && formattedFilters[key]) {
      if (formattedFilters[key].keywords) {
        if (!Array.isArray(formattedFilters[key].keywords)) {
          formattedFilters[key].keywords = [formattedFilters[key].keywords];
        }
        formattedFilters[key].keywords = formattedFilters[key].keywords.map(
          (val: string) => val.toLowerCase()
        );
      }
    }
  });

  if (formattedFilters.buyerCountry) {
    formattedFilters.buyer_country = formattedFilters.buyerCountry;
    delete formattedFilters.buyerCountry;
  }

  if (formattedFilters.internalStatus) {
    formattedFilters.internal_status = formattedFilters.internalStatus;
    delete formattedFilters.internalStatus;
  }

  Object.entries(statusOptions).forEach(([statusKey, statusValue]) => {
    if (formattedFilters[statusKey]?.keywords) {
      if (Array.isArray(formattedFilters[statusKey].keywords)) {
        formattedFilters[statusKey].keywords = formattedFilters[
          statusKey
        ].keywords.map((val: string) => getStatusApiValue(statusOptions, statusKey, val));
      } else {
        formattedFilters[statusKey].keywords = getStatusApiValue(
          statusOptions,
          statusKey,
          formattedFilters[statusKey].keywords
        );
      }
    }
  });

  if (typeof onSubmit === "function") {
    onSubmit(JSON.stringify(formattedFilters));
  } else {
    setFilteredData(filterAction(formattedFilters, initialData));
  }

  return formattedFilters;
}; 
